module.exports = __webpack_public_path__ + "static/media/igologic.d64d76c4.jpg";